import { createSlice } from "@reduxjs/toolkit";

export interface AlertsState {
  trade_signal_count: number;
  position_mismatch_count: number;
}

const initialState: AlertsState = {
  trade_signal_count: 0,
  position_mismatch_count: 0,
};

const alertsSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    setUnseenCounts: (state, action) => {
      state.trade_signal_count = action.payload.trade_signal_count;
      state.position_mismatch_count = action.payload.position_mismatch_count;
    },
  },
});

export default alertsSlice.reducer;
export const {
  setUnseenCounts,
} = alertsSlice.actions;
